module.exports = __webpack_public_path__ + "img/cubes.ffb31a92.png";